import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectsStyles = makeStyles((theme) =>
  createStyles({
    paginationBlock: {
      margin: '20px 0 0 0',
      display: 'flex',
      justifyContent: 'center'
    },

    modalHeader: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      padding: 16,
      background: '#F6F6F6'
    },

    filterTitle: {
      fontFamily: 'Montserrat',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '0em'
    },
    sidebarModal: {
      width: '375px',
      top: '65px',
      border: 'none',
      'overflow-y': 'auto',

      '& .makeStyles-leftColumnRoot-47': {
        backgroundColor: 'white'
      },

      [theme.breakpoints.down(600)]: {
        width: '100%'
      }
    },
    searchBar: {
      height: 64,
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
      borderRadius: '13px'
    },
    btnAddModelsContainer: {
      position: 'fixed',
      right: 14,
      bottom: 14,
      zIndex: 999
    },
    btnAddModels: {
      background: '#E52428 !important',
      height: '50px',
      padding: '13px 0px 6px 9px',
      minWidth: 'initial',
      width: '50px',
      color: 'white',
      borderRadius: '50%'
    },
    btnHeight: {
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      }
    },
    noData: {
      width: '100%',
      height: '50vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    noDataContent: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
      fontSize: 24,
      maxWidth: '783px',
      padding: '0 15px'
    },
    iconNoData: {
      maxWidth: 100,
      maxHeight: 100,
      marginBottom: 10
    }
  })
)
